import { render, staticRenderFns } from "./Accept_request.vue?vue&type=template&id=4aca0537"
import script from "./Accept_request.vue?vue&type=script&lang=js"
export * from "./Accept_request.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports